export default {
  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE',
  MODAL_TOGGLE: 'MODAL_TOGGLE',
  MODAL_REGISTER: 'MODAL_REGISTER',
};
